<template>
  <div>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="老师姓名">
          <el-input v-model="formInline.teacher" @blur="handleQuery" placeholder="请输入老师姓名"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="老师类型">
          <el-select v-model="formInline.post_id" clearable placeholder="请选择老师类型 " @change="handleQuery">
            <el-option v-for="(item,index) in $store.state.posts_teacher" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周次">
          <el-cascader v-model="formInline.weeks" :props="props" :options="options" @change="handleQuery" style="width:250px;"></el-cascader>
        </el-form-item> -->
        <!-- <el-form-item label="申请状态">
          <el-select v-model="formInline.apply_status" clearable placeholder="请选择申请状态" @change="handleQuery">
            <el-option v-for="(item,index) in $store.state.apply_status" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">教室申请</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column prop="serial_number" label="编号" width="80">
        </custom-table-column>
        <custom-table-column prop="training_name" label="教室名称" width="150">
        </custom-table-column>
        <custom-table-column fixed prop="class_name" label="班级名称" width="150">
        </custom-table-column>
        <custom-table-column fixed prop="course_name" label="课程名称" width="180">
        </custom-table-column>
        <custom-table-column prop="type" label="评价类型" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.type==1">学生评价实训课</span>
            <span v-if="scope.row.type==2">学生实习课表现评价</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="content" label="总评" min-width="200">
        </custom-table-column>
        <custom-table-column prop="score" label="评分" width="80">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleCheck(scope.row)" type="text" size="small">评价</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  title="评价" :visible.sync="checkDialogVisible" width="720px">
      <custom-table :data="itemData" :span-method="objectSpanMethod" show-summary :summary-method="getSummaries" :cell-style="cellStyle" border style="width: 100%; margin-top: 20px">
        <custom-table-column prop="item" label="评价项目" width="180">
        </custom-table-column>
        <custom-table-column prop="content" label="评价内容">
          <template slot-scope="scope">
            <span>{{`${scope.row.content}(${scope.row.score}分)`}}</span>
          </template>
        </custom-table-column>
        <!-- <custom-table-column prop="score"  width="48" label="权重">
        </custom-table-column> -->
        <custom-table-column prop="score" width="48" label="分值">
        </custom-table-column>
        <custom-table-column width="144" prop="value" label="得分">
          <template slot-scope="scope">
            <el-input-number v-model="gradeObj.items[scope.$index].score" style="width:120px;" :min="1" :max="scope.row.score"></el-input-number>
          </template>
        </custom-table-column>
      </custom-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTeacherScore">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import Vue from 'vue';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      classRooms: [],
      schoolYears: [],
      options: [],
      props: {
        children: 'options',
      },
      types1: [],
      types2: [],
      formInline: {
        teacher: '',
      },
      checkDialogVisible: false,
      ruleForm: {
        classroom_name: '',
        school_year: '',
        school_term: '',
        sector: '', //节次 1,2
        weeks: '', //周次 1,2,3 1-3
        week: '',
        // time_quantum: '', //上午 中午 下午 晚上
      },
      rules: {
        classroom_name: [{ required: true, message: '请选择教室', trigger: 'change' }],
        school_year: [{ required: true, message: '请选择学年', trigger: 'change' }],
        school_term: [{ required: true, message: '请选择学期', trigger: 'change' }],
        weeks: [{ required: true, message: '请输入周次', trigger: 'blur' }],
        // time_quantum: [{ required: true, message: '请选择时段', trigger: 'change' }],
        sector: [{ required: true, message: '请选择节次', trigger: 'change' }],
        week: [{ required: true, message: '请选择星期', trigger: 'change' }],
      },
      type: 'add',
      tableName: '老师课表汇总统计',
      itemData: [],
      map: null,
      rarr: [],
      sarr: [],
      istab: true,
      gradeObj: {
        id: '',
        content: '',
        items: [],
      },
    };
  },
  created() {
    this.sarr.push(0);
  },
  mounted() {
    // this.getList();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    async handleCheck(row) {
      this.checkDialogVisible = true;
      this.sarr = [];
      this.rarr = [];
      this.sarr.push(0);
      this.gradeObj = {
        id: '',
        content: '',
        items: [],
      };
      this.gradeObj.id = row.id;
      this.getTypeItem(row.type)
      // let params = { type: row.type };
      // let res = await this.$api.instance.getQualityItem(params);
      // if (res.code == 0) {
      //   let data = res.data.map((item) => {
      //     item.max_score = item.score;
      //     return item;
      //   });
      //   this.gradeObj.items = this.$until.deepCopy(data);
      //   this.itemData = res.data;
      //   let arr = [];
      //   this.itemData.map((item) => {
      //     arr.push(item.item);
      //   });
      //   this.map = arr.reduce((m, x) => m.set(x, (m.get(x) || 0) + 1), new Map());
      //   let num = 0;
      //   let that = this;
      //   this.map.forEach(function (value, key, map) {
      //     num += value;
      //     that.sarr.push(num);
      //     that.rarr.push(value);
      //   });
      //   num = 0;
      // }
    },
    async submitTeacherScore() {
      let params = this.gradeObj;
      let res = await this.$api.update.doGrade(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '打分成功成功！',
        });
        this.checkDialogVisible = false;
        this.getList();
      }
    },
    getTypeItem(type) {
      if (type == 1) {
        if (this.types1 && this.types1.length) {
          this.itemData = this.types1
        } else {
          this.typeeItems(type);
        }
      }
      if (type == 2) {
        if (this.types2 && this.types2.length) {
          this.itemData = this.types2
        } else {
          this.typeeItems(type);
        }
      }
    },
    async typeeItems(type) {
      let res = await this.$api.instance.getTypeItems({type});
      if (res.code == 0&& res.data) {
        if(type==1){
          this.types1 = res.data
          this.itemData = this.types1
        }else{
          this.types2 = res.data
          this.itemData = this.types2
        }
         let data = res.data.map((item) => {
          item.max_score = item.score;
          return item;
        });
        this.gradeObj.items = this.$until.easyDeepCopy(data);
        let arr = [];
        this.itemData.map((item) => {
          arr.push(item.item);
        });
        this.map = arr.reduce((m, x) => m.set(x, (m.get(x) || 0) + 1), new Map());
        console.log(this.map)
        let num = 0;
        let that = this;
        this.map.forEach(function (value, key, map) {
          num += value;
          that.sarr.push(num);
          that.rarr.push(value);
        });
        // num = 0;
      }
    },
    handleCancel(id) {
      this.delText = '是否取消该申请';
      this.handleDelet(id);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    handleContent() {
      console.log(111);
    },
    getSummaries(param) {
      const { columns, data } = param;
      // console.log(param);
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '综合评价';
          return;
        }
        if (index === 1) {
          // sums[index] = <textarea onClick="handleContent">111</textarea>;
          const vm = new Vue();
          const h = vm.$createElement;
          let that = this;
          const inputObj = h(
            //创建VNode对象
            'el-input',
            {
              attrs: {
                type: 'textarea',
                rows: 4,
                placeholder: '请输入评价',
                value: that.gradeObj.content, //实现双向绑定
              },
              on: {
                input: function (value) {
                  that.gradeObj.content = value;
                },
              },
              // style: {
              //   color: 'red',
              // },
            }
          );
          sums[index] = inputObj;
          return;
        }
        if (index === 2) {
          sums[index] = '总分';
          return;
        }
        let values = [];
        if (column.property == 'value') {
          values = this.gradeObj.items.map((item) => {
            return Number(item['score']);
          });
        }
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else {
          sums[index] = '';
        }
      });
      // console.log(sums);
      return sums;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        return 'text-align:center';
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(rowIndex, columnIndex);
      if (columnIndex === 0) {
        // let r1 = map;
        // console.log(rowIndex,this.sarr)
        for (let i = 0; i < this.sarr.length; i++) {
          if (rowIndex == this.sarr[i] && this.sarr[i] != this.itemData.length) {
            return {
              rowspan: this.rarr[i],
              colspan: 1,
            };
          }
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
    async cancelApply() {
      let params = { id: this.delid };
      let res = await this.$api.delet.cancelApply(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '取消成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async creatClassroomApply() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.sector = params.sector.join(',');
      let res = await this.$api.creat.creatClassroomApply(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMissClass() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateMissClass(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getExeclList() {
      let params = {
        page: 1,
        size: 9999,
        teacher: this.formInline.teacher,
      };
      let res = await this.$api.query.getQualitys(this.$until.deleteNullPrototype(params));
      if (res.code == 0 && res.data) {
        this.execlData = res.data.data;
        this.exportExcel();
        // this.total = res.data.total;
      }
    },
    async getList() {
      let params = {
        current: this.$refs.pageChild.page,
        pageSize: this.$refs.pageChild.size,
        type:2
        // teacher: this.formInline.teacher,
        // grade: 1,
      };
      let res = await this.$api.query.getCourses(this.$until.deleteNullPrototype(params));
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.el-select .el-tag {
  height: 24px;
  line-height: 24px;
}
</style>
